import {c, color, theme, is_mobile} from './modules/settings.js';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import saveAs from 'file-saver';

(function ($) {
	$(function () {
		$('.downloadcenter').each(function () {

			const $inputs = $(this).find('.dc__item__checkbox-input');
			const $filesize = $(this).find('.js-dc-controls-filesize');
			const $button = $(this).find('.js-dc-controls-zip');

			$inputs.on('change', function () {
				reload_size();
			});

			$button.on('click', function () {
				const zip = new JSZip();
				const urls = [];
				$inputs.each(function () {
					if ($(this).prop('checked')) {
						urls.push($(this).attr('data-url'));
					}
				});

				if (urls.length === 0) {
					return;
				}

				const zipFilename = 'dormakaba-downloads.zip';
				let count = 0;

				for (let i = 0; i < urls.length; i++) {
					const fileparts = urls[i].split('/');
					const filename = fileparts[fileparts.length - 1];
          JSZipUtils.getBinaryContent(urls[i], function (err, data) {
            if (err) {
              throw err;
						}
						zip.file(filename, urlToPromise(urls[i]), {binary: true});
						count++;
            if (count === urls.length) {
              //console.log("IT HAS TO WORK");
							zip.generateAsync({type: 'blob'}).then(function (content) {
                saveAs(content, zipFilename);
							});
						}
					});
				}


			});

			function urlToPromise(url) {
				return new Promise(function (resolve, reject) {
					JSZipUtils.getBinaryContent(url, function (err, data) {
						if (err) {
							reject(err);
						} else {
							resolve(data);
						}
					});
				});
			}

			function reload_size() {
				let size = 0;
				$inputs.each(function () {
					if ($(this).prop('checked')) {
						size = size + parseInt($(this).attr('data-size'));
					}
				});

				if (size === 0) {
					$button.attr('disabled', 'true');
				} else {
					$button.removeAttr('disabled');
				}

				$filesize.text(humanFilesize(size));
			}
		});
	});

	function humanFilesize(bytes) {
		const size = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
		const factor = Math.floor((bytes.toString().length - 1) / 3);

		const newSize = Math.round(bytes / Math.pow(1024, factor));
		return `${newSize} ${size[factor]}`;
	}
})(jQuery);
